import { useMemo } from "react";
import { BofuTabCode, BofuTabItem } from "@interfaces/response";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";

interface UseBofuTabsReturn {
  currentTab: BofuTabItem | undefined;
  nextTab: BofuTabItem | undefined;
  isLastTab: boolean;
}

const useBofuTabs = (tabCode: BofuTabCode): UseBofuTabsReturn => {
  const bofuTabs = useSelector((state: RootState) => state.bofu.bofu_tabs_obj);

  const result = useMemo(() => {
    // transform bofuTabs to array
    let tabsToArray: BofuTabItem[] = Object.values(bofuTabs) as BofuTabItem[];
    tabsToArray = tabsToArray.filter((item) => item);

    // filter active tabs
    const activeTabs = tabsToArray.filter((item) => item).filter((tab) => tab.is_active);

    // find current tab by tabCode
    const currentTab: BofuTabItem | undefined = activeTabs.find((tab) => tab.code === tabCode);

    // if current tab is not found, return undefined
    if (!currentTab) {
      return {
        currentTab: undefined,
        nextTab: undefined,
        isLastTab: false,
      };
    }

    // find next tab by currentTab order
    const nextTab: BofuTabItem | undefined = activeTabs.find((tab) => tab.order === currentTab.order + 1);

    // identify if current tab is last tab by comparing currentTab order with activeTabs length
    const isLastTab = nextTab === undefined ? true : false;

    return {
      currentTab,
      nextTab,
      isLastTab,
    };
  }, [bofuTabs, tabCode]);

  return result;
};

export default useBofuTabs;
